import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { ActionButton } from '../../ReactComponent/Modal/css';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import { CheckmarkIcon, HeaderContainer, ErrorList } from './css';

const ImportModal = ({
  isOpen, onClose, errorData, noFile,
}) => {
  // eslint-disable-next-line react/no-unstable-nested-components
  const HeaderText = () => {
    if (errorData.length > 0) {
      return t('lblImportErrorMessageHeader');
    }

    if (noFile) {
      return (
        <>

          <CheckmarkIcon />
          {t('lblNoFileForDownloadHeader')}

        </>
      );
    }

    return t('lblFileUploadedHeader');
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const DescriptionText = () => {
    if (errorData.length > 0) {
      return (
        <>
          <P field={t('lblImportUploadErrorDesc')} />
          <ErrorList>
            {
              errorData.map((eachErrorMessage) => {
                const errorMessage = eachErrorMessage.errors.map((element) => (<ul key={element}><li key={element}>{element.errorMessage}</li></ul>));
                return (
                  <li key={eachErrorMessage}>
                    {eachErrorMessage.statusCode === 200
                      ? eachErrorMessage.message : eachErrorMessage.errors.length > 1
                        ? errorMessage : eachErrorMessage.errors[0].errorMessage }
                  </li>
                );
              })
            }
          </ErrorList>
        </>
      );
    }

    if (noFile) {
      return '';
    }

    return <P field={t('lblImportUploadSucessDesc')} />;
  };

  const header = () => (
    <HeaderContainer>
      <HeaderText />
    </HeaderContainer>
  );

  const content = () => (
    <DescriptionText />
  );

  const actions = () => (
    <ActionButton className="active" iconRightArrow onClick={onClose}>
      {t('Okay')}
    </ActionButton>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

ImportModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  errorData: PropTypes.array,
  noFile: PropTypes.bool,
};

export default ImportModal;
